"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var StyleButtonStore_1 = __importDefault(require("./StyleButtonStore"));
var lodash_1 = require("lodash");
var StyleButton_1 = __importDefault(require("./StyleButton"));
var SelectorUtils_1 = require("@CommonFrontend/Utils/SelectorUtils");
var StyleButton_css_1 = require("./StyleButton.css");
var StyleButtonAngular = (function () {
    function StyleButtonAngular(invoke, createUi, block, make, projectEvents, usingFeature, Tooltip, blockStore, stylePermissionStore, blockList) {
        this.onClick = lodash_1.noop;
        var usingTCDC = (0, FeatureFlag_1.isUsingTCDC)(usingFeature);
        if (usingTCDC) {
            var openBrandSetup = invoke(require("DreamCoat/BrandSetUp/OpenBrandSetup").default);
            var shortcutStyleControls = invoke(require("../../StyleControls/attachShortcutControls"), null, {
                openBrandSetup: openBrandSetup,
            });
            var savedStyleControls = invoke(require("../../StyleControls/attachSavedStyleControls"));
            var shortcutMenu_1 = make(Tooltip, {
                targetSelector: "#".concat(block.$id, " ").concat((0, SelectorUtils_1.toSelector)(StyleButton_css_1.blockStyleButton)),
                options: {
                    position: "bottom",
                    contents: shortcutStyleControls,
                    spacing: 7,
                    container: ".project-block--id-".concat(block.$id),
                    ignoreClickAwayElems: [".style-button", ".style-shortcut__option-menu"],
                    closeOnClickAway: true,
                },
            });
            shortcutMenu_1.setOnHide(function () { return blockStore.turnOffAnimation(); });
            var savedStyleMenu_1 = make(Tooltip, {
                targetSelector: "#".concat(block.$id, " ").concat((0, SelectorUtils_1.toSelector)(StyleButton_css_1.styleLibraryButton)),
                options: {
                    position: "bottom",
                    contents: savedStyleControls,
                    spacing: 7,
                    container: ".project-block--id-".concat(block.$id),
                    ignoreClickAwayElems: [".style-button"],
                    closeOnClickAway: true,
                },
            });
            var onBlockStyleButtonClick = function (event) {
                event === null || event === void 0 ? void 0 : event.stopPropagation();
                if (shortcutMenu_1 === null || shortcutMenu_1 === void 0 ? void 0 : shortcutMenu_1.isCurrentlyShowing()) {
                    return shortcutMenu_1.hide();
                }
                else if (savedStyleMenu_1 === null || savedStyleMenu_1 === void 0 ? void 0 : savedStyleMenu_1.isCurrentlyShowing()) {
                    savedStyleMenu_1.hide(true);
                    return shortcutMenu_1.show();
                }
                else {
                    return shortcutMenu_1.show();
                }
            };
            var onLibraryClick = function () {
                if (savedStyleMenu_1 === null || savedStyleMenu_1 === void 0 ? void 0 : savedStyleMenu_1.isCurrentlyShowing()) {
                    return savedStyleMenu_1.hide();
                }
                else if (shortcutMenu_1 === null || shortcutMenu_1 === void 0 ? void 0 : shortcutMenu_1.isCurrentlyShowing()) {
                    shortcutMenu_1.hide(true);
                    return savedStyleMenu_1.show();
                }
                else {
                    return savedStyleMenu_1.show();
                }
            };
            this.ui = invoke(StyleButton_1.default, null, {
                styleButtonStore: new StyleButtonStore_1.default(stylePermissionStore, usingFeature, block.type),
                onLibraryClick: onLibraryClick,
                onBlockStyleButtonClick: onBlockStyleButtonClick,
                isLastBlock: function () { return blockList.getIndex(block) === blockList.getLength() - 1; },
            });
        }
        else {
            this.ui = createUi(require("./StyleButton.html"));
            this.onClick = function () {
                return projectEvents.emit("bigComponentOpened", {
                    type: "Style",
                    blockId: block._id,
                });
            };
        }
    }
    return StyleButtonAngular;
}());
exports.default = StyleButtonAngular;
